<template>
  <div class="view-contanier">
    <div class="header">
      <div class="tab">
        <span
          class="tabItem"
          :class="{ active: active === -1 }"
          @click="changeType(-1)"
        >全部({{ (tabNumer?.find((a) => a.type === 0)?.qty || 0) + (tabNumer?.find((a) => a.type === 4)?.qty || 0) }})</span
        >
        <span
          class="tabItem"
          :class="{ active: active === 0 }"
          @click="changeType(0)"
        >处理中({{ tabNumer?.find((a) => a.type === 0)?.qty || 0 }})</span
        >
        <span
          class="tabItem"
          :class="{ active: active === 4 }"
          @click="changeType(4)"
        >完结({{ tabNumer?.find((a) => a.type === 4)?.qty || 0 }})</span
        >
      </div>
      <div class="opt">
        <div class="search">
          <el-popover
            ref="popover"
            placement="top"
            class="searchPop"
            title="批量搜索"
            trigger="click"
            width="378"
          >
            <div class="close" @click="closeSearchPanel">
              <i class="el-icon-close"></i>
            </div>
            <base-muti-input
              ref="baseMutiInput"
              v-model="referenceNumber"
              :default="referenceNumber"
            ></base-muti-input>
            <div style="text-align: right; margin: 16px 0 0">
              <el-button size="small" @click="handleEmpty">清空</el-button>
              <div class="sure" @mousedown="handleConfirm">确定</div>
            </div>
          </el-popover>
          <el-input
            :value="searchVal"
            placeholder="请输入提单号搜索"
            class="input-search"
            @focus="handleFocus"
          ></el-input>
          <div class="btn-search" @click="handleConfirm">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div v-debounce-click="batchExport" class="import">
          <img src="@/assets/images/bill/import.png" alt="" />导出
        </div>
        <BaseFilter
          :isActive="isActive"
          :width="892"
          @sendFilter="sendFilter"
          @reset="reset"
        >
          <div class="filter">
            <el-form ref="form" :model="filterList" label-width="110px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="客户">
                    <el-select
                      v-model="filterList.companyId"
                      style="width: 310px"
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in companyOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="12"
                ><el-form-item label="业务员">
                  <el-select
                    v-model="filterList.saleIds"
                    style="width: 310px"
                    filterable
                    placeholder="请选择"
                    multiple
                  >
                    <el-option
                      v-for="item in userOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="创建日期">
                    <el-date-picker
                      v-model="filterList.createOn"
                      style="width: 310px"
                      type="daterange"
                      range-separator="至"
                      align="center"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      unlink-panels
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="ETA">
                    <el-date-picker
                      v-model="filterList.eta"
                      style="width: 310px"
                      type="daterange"
                      range-separator="至"
                      align="center"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      unlink-panels
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="ETD">
                    <el-date-picker
                      v-model="filterList.etd"
                      style="width: 310px"
                      type="daterange"
                      range-separator="至"
                      align="center"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      unlink-panels
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker> </el-form-item
                  ></el-col>
                <el-col :span="12">
                  <el-form-item label="清关放行时间">
                    <el-date-picker
                      v-model="filterList.releaseDate"
                      style="width: 310px"
                      type="daterange"
                      range-separator="至"
                      align="center"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      unlink-panels
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="卸船日期">
                    <el-date-picker
                      v-model="filterList.dischargeDate"
                      style="width: 310px"
                      type="daterange"
                      range-separator="至"
                      align="center"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      unlink-panels
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker> </el-form-item
                  ></el-col>
                <el-col :span="12">
                  <el-form-item label="到卸货港日期">
                    <el-date-picker
                      v-model="filterList.dischargeHarborDate"
                      style="width: 310px"
                      type="daterange"
                      range-separator="至"
                      align="center"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      unlink-panels
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker> </el-form-item
                  ></el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="仓库">
                    <el-input
                      v-model="filterList.code"
                      style="width: 310px"
                      placeholder="请输入仓库"
                    >
                    </el-input> </el-form-item
                  ></el-col>
                <el-col :span="12">
                  <el-form-item label="还空柜日期">
                    <el-date-picker
                      v-model="filterList.emptyReturnedDate"
                      style="width: 310px"
                      type="daterange"
                      range-separator="至"
                      align="center"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      unlink-panels
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker> </el-form-item
                  ></el-col>
                <!-- <el-col :span="12">
                  <el-form-item label="POD日期">
                    <el-date-picker
                      v-model="filterList.podDate"
                      style="width: 310px"
                      type="daterange"
                      range-separator="至"
                      align="center"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      unlink-panels
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker> </el-form-item
                  ></el-col> -->
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提柜日期">
                    <el-date-picker
                      v-model="filterList.pickUpDate"
                      style="width: 310px"
                      type="daterange"
                      range-separator="至"
                      align="center"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      unlink-panels
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </BaseFilter>
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="tableData"
        :pageIndex="pagerConfig.pageIndex"
        :pageSize="pagerConfig.pageSize"
        :loading="loading"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
      >
        <template slot="harborName" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">始发港/机场</span>{{ row.scope.originHarborName }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">卸货港</span>{{ row.scope.dischargeHarbor }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType2">目的港/机场</span>{{ row.scope.destinationHarborName }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType3">船名/航次</span>{{ row.scope.vesselName }}/{{ row.scope.voyageNo }}
          </p>
        </template>
        <template slot="cargoData" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">件数</span>{{ row.scope.qty }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">实重</span>{{ row.scope.weight }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType2">方数</span>{{ row.scope.square }}
          </p>
        </template>
        <template slot="ETDATD" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">ETD</span>{{ row.scope.etd | dateFilete }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">ATD</span>{{ row.scope.atd | dateFilete }}
          </p>
        </template>
        <template slot="ETAATA" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">ETA</span>{{ row.scope.eta | dateTimeFilter }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">ATA</span>{{ row.scope.ata | dateTimeFilter }}
          </p>
        </template>
        <template slot="anDo" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">AN日期</span>{{ row.scope.anDate | dateFilete }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">DO日期</span>{{ row.scope.doDate | dateFilete }}
          </p>
        </template>
        <template slot="terminalName" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">码头</span>{{ row.scope.terminalName }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">卸船日期</span>{{
              row.scope.dischargeDate | dateFilete
            }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType2">available日期</span>{{
              row.scope.availableDate | dateFilete
            }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType3">LFD日期</span>{{ row.scope.lastFreeDate | dateFilete }}
          </p>
        </template>
        <template slot="pickup" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">预约提柜日期</span>{{
              row.scope.reservedPickUpDate | dateFilete
            }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">提柜日期</span>{{ row.scope.picPickUpDate | dateFilete }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType2">预约直送日期</span>{{
              row.scope.reservedDirectDate | dateFilete
            }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType3">直送日期</span>{{ row.scope.directDate | dateFilete }}
          </p>
        </template>
        <template slot="deliveryInfo" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">ISA/预约号</span>{{ row.scope.isISA ? "是" : "否" }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">BOL</span>{{ row.scope.isBOL ? "是" : "否" }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType2">POD</span>{{ row.scope.isPOD ? "是" : "否" }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType3">POD日期</span>{{ row.scope.podDate | dateFilete }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType4">POD时效</span>{{ row.scope.podPrescription }}
          </p>
        </template>
        <template slot="isLineHold" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">Freight</span>{{ row.scope.terminalFeeNote }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">Customs</span>{{ row.scope.terminalCustoms }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType2">Terminal hold</span>{{ row.scope.terminalHoldNote }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType3">Terminal Fee</span>{{ row.scope.terminalFeeNote }}
          </p>
        </template>
        <template slot="puNumber" slot-scope="row">
          <div style="display: flex;">
            <div style="width: 160px;">
              <p>
                <span
                  class="pickUpType"
                  :class="`pickUpType0`"
                >
                  PICK UP#
                </span>
                {{ row.scope.puNo }}
              </p>
              <p>
                <span
                  class="pickUpType"
                  :class="`pickUpType1`"
                >
                  PU# 日期
                </span>
                {{ row.scope.puDate }}
              </p>
            </div>
          </div>
        </template>
        <template slot="code" slot-scope="row">
          {{ row.scope.code }}
          <i class="el-icon-edit" title="修改仓库" style="color:rgb(18,88,188); cursor: pointer" @click="editWareHouse(row.scope)" />
        </template>
        <template slot="directRemark" slot-scope="row">
          <p style="max-width: 80px;display: inline-block; overflow: hidden;    vertical-align: bottom;"> {{ row.scope.directRemark }}</p>
          <i class="el-icon-edit" @click="editRemark(row.scope)" />
        </template>
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-permissson="'update'"
                  class="opt-item"
                  @click="update(row.scope)"
                >修改</el-button
                >
                <el-button
                  v-if="active === 0"
                  class="opt-item"
                  @click="finishBill(row.scope)"
                >完结</el-button
                >
              </div>
            </div>
            <img slot="reference" src="@/assets/images/table/opt.png" />
          </el-popover>
        </template>
      </BaseTable>
    </div>
    <UpdateDirectDeliveryDialog
      :dialogVisible="dialogVisible"
      :rowData="rowData"
      @ok="ok"
      @cancel="cancel"
    ></UpdateDirectDeliveryDialog>
    <TruckDetailDrawer
      :drawer="drawer"
      :rowData="rowData"
      :type="1"
      :mblSendWayId="rowData?.id"
      @close="drawer = false"
    ></TruckDetailDrawer>
    <EditWarehouseDialog
      :dialogVisible="dialogVisible1"
      :rowData="rowData"
      @ok="dialogVisible1 = false;getList(pagerConfig)"
      @cancel="dialogVisible1 = false">
    </EditWarehouseDialog>
    <UpdateDirectDeliveryRemarkDialog
      :dialogVisible="dialogVisible2"
      :rowData="rowData"
      @ok="dialogVisible2 = false;getList(pagerConfig)"
      @cancel="dialogVisible2 = false">
    </UpdateDirectDeliveryRemarkDialog>
    <PuDateDialog
      :dialogVisible="dialogVisible3"
      :rowData="rowData"
      @ok="
        dialogVisible3 = false;
        getList(pagerConfig);
      "
      @cancel="dialogVisible3 = false"></PuDateDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseFilter = () => import('@/components/filter/BaseFilter')
import TruckDetailDrawer from './components/TruckDetailDrawer.vue'
import UpdateDirectDeliveryDialog from './components/UpdateDirectDeliveryDialog'
import PuDateDialog from './components/PuDateDialog'
const BaseMutiInput = () => import('@/components/base/BaseMutiInput')
import EditWarehouseDialog from './components/EditWarehouseDialog'
import UpdateDirectDeliveryRemarkDialog from './components/UpdateDirectDeliveryRemarkDialog'
import { directDeliveryPages, containerFinished } from '@/api/bill'
import { getSaleList } from '@/api/system'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import { derive } from '@/utils/common'
import { myMixins } from '@/mixins'
export default {
  name: 'DirectDeliveryList',
  components: { BaseTable, BaseFilter, UpdateDirectDeliveryDialog, BaseMutiInput, TruckDetailDrawer, EditWarehouseDialog, UpdateDirectDeliveryRemarkDialog, PuDateDialog },
  filters: {
    dateFilete: function(date) {
      if (date) {
        const newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
        return newDate[0]
      } else {
        return ''
      }
    },
    dateTimeFilter(time) {
      if (!time) return ''
      return time.split(' ')[0]
    }
  },
  mixins: [myMixins],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      pagerConfig: {
        pageIndex: 1,
        pageSize: 20
      },
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '150px',
            isSort: true
          },
          {
            filed: 'companyName',
            label: '客户',
            width: '150px'
          },
          {
            filed: 'containerNumber',
            label: '柜号',
            isCopy: true,
            width: '150px'
          },
          {
            filed: 'mblNo',
            label: '提单号',
            isCopy: true,
            width: '150px'
          },
          {
            filed: 'blNo',
            label: '分单号',
            isCopy: true,
            width: '150px'
          },
          {
            filed: 'containertype',
            label: '柜型',
            width: '100px'
          },
          {
            filed: 'harborName',
            label: '港口信息',
            width: '310px',
            isCustom: true
          },
          {
            filed: 'code',
            label: '直送仓库',
            width: '120px',
            isCustom: true
          },
          {
            filed: 'cargoData',
            label: '货物数据',
            width: '190px',
            isCustom: true
          },
          {
            filed: 'ETDATD',
            label: '开船日期',
            width: '190px',
            isCustom: true
          },
          {
            filed: 'dischargeHarborDate',
            label: '到卸货港日期',
            width: '120px',
            formatter: row => {
              if (!row.dischargeHarborDate) return ''
              return row.dischargeHarborDate.split(' ')[0]
            }
          },
          {
            filed: 'ETAATA',
            label: '到港日期',
            width: '200px',
            isCustom: true
          },
          {
            filed: 'puNumber',
            label: 'PU#日期',
            width: '200px',
            isCustom: true
          },
          {
            filed: 'releaseDate',
            label: '清关放行时间',
            width: '120px'
          },
          {
            filed: 'anDo',
            label: 'AN/DO日期',
            width: '200px',
            isCustom: true
          },
          {
            filed: 'terminalName',
            label: '提柜信息',
            width: '200px',
            isCustom: true
          },
          {
            filed: 'isLineHold',
            label: '码头状态',
            width: '120px',
            isCustom: true
            // formatter: (row) => (row.isLineHold ? '是' : '否'),
          },
          {
            filed: 'pickup',
            label: '码头信息',
            width: '200px',
            isCustom: true
          },
          {
            filed: 'deliveryInfo',
            label: '送仓信息',
            width: '200px',
            isCustom: true
          },
          {
            filed: 'emptyReturnedDate',
            label: '还空柜日期',
            width: '150px',
            formatter: row => {
              if (!row.emptyReturnedDate) return ''
              return row.emptyReturnedDate.split(' ')[0]
            }
          },
          {
            filed: 'clearenceSupplierName',
            label: '清关代理',
            width: '150px'
          },
          {
            filed: 'pickUpSupplierName',
            label: '提柜代理',
            width: '150px'
          },
          {
            filed: 'directRemark',
            label: '备注',
            width: '150px',
            isCustom: true
          },
          {
            filed: 'operatorHanders',
            label: '操作负责人',
            width: '150px'
          },
          {
            filed: 'customerHanders',
            label: '客服负责人',
            width: '150px'
          },
          {
            filed: 'saleName',
            label: '销售员',
            width: '150px'
          }
        ],
        columns: [],
        total: 0,
        tableRowClassName({ row }) {
          if (dayjs().isAfter(dayjs(row.validTo))) {
            return 'error-row'
          }
        }
      },
      height: 0,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      drawer: false,
      rowData: {},
      commData: [],
      userOptions: [],
      filterList: {
        code: '',
        createOn: '',
        saleIds: '',
        companyId: '',
        releaseDate: '',
        eta: '',
        etd: '',
        dischargeDate: '',
        dischargeHarborDate: '',
        emptyReturnedDate: '',
        pickUpDate: ''
      },
      typeOptions: [
        {
          label: '应付',
          value: 1
        },
        {
          label: '应收',
          value: 0
        }
      ],
      isActive: false,
      sortable: {
        sortField: undefined,
        sortBy: undefined
      },
      referenceNumber: '',
      searchVal: '',
      tabNumer: [],
      active: -1
    }
  },
  computed: {
    ...mapGetters(['addressDropOption', 'companyDrapdown']),
    companyOptions() {
      return this.companyDrapdown
    },
    commOptions: function() {
      const arr = []
      this.commData.map((item) => {
        arr.push({
          label: item.description,
          value: item.dbValue
        })
      })
      return arr
    }
  },
  created() {
    this.getList(this.pagerConfig)
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
    this.getUserList()
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
  },
  methods: {
    getUserList() {
      getSaleList().then((res) => {
        if (res.success) {
          const arr = []
          res.data.map((item) => {
            arr.push({
              value: item.id,
              label: item.nameCH
            })
          })
          this.userOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    detail(row) {
      this.drawer = true
      this.rowData = row
    },
    getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            status: this.active,
            ...this.sortable,
            ...this.formatterFilter(),
            numberArray: this.searchVal ? this.searchVal.split(';') : undefined
          }
        }
        directDeliveryPages(params).then((res) => {
          if (res.success) {
            this.loading = false
            this.tableData.total = res.data.total
            this.tableData.columns = res.data.list
            this.tabNumer = res.data.tabNumer
          } else {
            this.loading = false
            this.$message.error(res.errorMessage)
          }
        })
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    update(row) {
      this.rowData = row
      this.dialogVisible = true
    },
    finishBill(row) {
        this.$confirm('是否完结该柜子', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          iconClass: 'warning',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          center: true
        })
          .then(async() => {
            this.loading = true
            const res = await containerFinished({ containerId: row.containerId })
            this.loading = false
            if (res.success) {
              this.getList(this.pagerConfig)
              this.$message.success('完结成功')
            } else {
              this.$message.error(res.errorMessage)
            }
          })
          .catch(() => {})
    },
    changeType(type) {
      this.active = type
      this.getList(this.pagerConfig)
    },
    handlePageChange(pager) {
      this.pagerConfig = {
        ...this.pagerConfig,
        ...pager
      }
      const params = {
        ...this.pagerConfig,
        ...pager
      }
      this.getList(params)
    },
    sortChange(orderObj) {
      if (orderObj.order) {
        this.sortable = {
          sortField: orderObj.prop,
          sortBy: orderObj.order === 'asc' ? 0 : 1
        }
      } else {
        this.sortable = {}
      }
      this.getList(this.pagerConfig)
    },
    // add() {
    //   this.dialogVisible = true
    // },
    ok() {
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pagerConfig = params
      this.getList(params)
      this.cancel()
    },
    cancel() {
      this.dialogVisible = false
      this.rowData = {}
    },
    sendFilter() {
      if (
        this.filterList.code !== '' ||
        this.filterList.companyId !== '' ||
        this.filterList.createOn !== '' ||
        this.filterList.releaseDate?.length !== 0 ||
        this.filterList.eta?.length !== 0 ||
        this.filterList.etd?.length !== 0 ||
        this.filterList.dischargeDate?.length !== 0 ||
        this.filterList.dischargeHarborDate?.length !== 0 ||
        this.filterList.emptyReturnedDate?.length !== 0 ||
        this.filterList.pickUpDate?.length !== 0
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pagerConfig = params
      this.getList(params)
    },
    reset() {
      this.filterList = {
        code: '',
        createOn: '',
        saleIds: '',
        companyId: '',
        releaseDate: '',
        eta: '',
        etd: '',
        dischargeDate: '',
        dischargeHarborDate: '',
        emptyReturnedDate: '',
        pickUpDate: ''
      }
      this.isActive = false
    },
    formatterFilter() {
      const params = []
      if (this.filterList.createOn !== '' && this.filterList.createOn && this.filterList.createOn.length > 0) {
        params.push({
          type: 'CreateOn',
          start: this.filterList.createOn[0],
          end: this.filterList.createOn[1]
        })
      }
      if (this.filterList.releaseDate !== '' && this.filterList.releaseDate && this.filterList.releaseDate.length > 0) {
        params.push({
          type: 'ReleaseDate',
          start: this.filterList.releaseDate[0],
          end: this.filterList.releaseDate[1]
        })
      }
      if (this.filterList.eta !== '' && this.filterList.eta && this.filterList.eta.length > 0) {
        params.push({
          type: 'ETA',
          start: this.filterList.eta[0],
          end: this.filterList.eta[1]
        })
      }
      if (this.filterList.etd !== '' && this.filterList.etd && this.filterList.etd.length > 0) {
        params.push({
          type: 'PickUpDate',
          start: this.filterList.pickUpDate[0],
          end: this.filterList.pickUpDate[1]
        })
      }
      if (this.filterList.dischargeDate !== '' && this.filterList.dischargeDate && this.filterList.dischargeDate.length > 0) {
        params.push({
          type: 'DischargeDate',
          start: this.filterList.dischargeDate[0],
          end: this.filterList.dischargeDate[1]
        })
      }
      if (this.filterList.dischargeHarborDate !== '' && this.filterList.dischargeHarborDate && this.filterList.dischargeHarborDate.length > 0) {
        params.push({
          type: 'DischargeHarborDate',
          start: this.filterList.dischargeHarborDate[0],
          end: this.filterList.dischargeHarborDate[1]
        })
      }
      if (this.filterList.emptyReturnedDate !== '' && this.filterList.emptyReturnedDate && this.filterList.emptyReturnedDate.length > 0) {
        params.push({
          type: 'EmptyReturnedDate',
          start: this.filterList.emptyReturnedDate[0],
          end: this.filterList.emptyReturnedDate[1]
        })
      }
      if (this.filterList.pickUpDate !== '' && this.filterList.pickUpDate && this.filterList.pickUpDate.length > 0) {
        params.push({
          type: 'pickUpDate',
          start: this.filterList.pickUpDate[0],
          end: this.filterList.pickUpDate[1]
        })
      }
      return {
        code: this.filterList.code !== '' ? this.filterList.code : undefined,
        dateItems: params,
        companyId:
          this.filterList.companyId !== ''
            ? this.filterList.companyId
            : undefined,
            saleIds:
          this.filterList.saleIds && this.filterList.saleIds.length > 0
            ? this.filterList.saleIds
            : undefined
      }
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.initList()
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
        if (this.referenceNumber && this.referenceNumber !== '') {
          this.searchVal = this.referenceNumber.join(';')
        }
        this.$refs.popover.doClose()
        // todo 重置filter
        this.filterList = {}
        const param = {
          pageIndex: 1,
          pageSize: 20
        }
        this.pagerConfig = param
        this.isActive = false
        this.getList(param)
      }, 0)
    },
    async batchExport() {
      this.loading = true
      await derive('mbl/exportDelivery', 'post', this.formatterFilter())
      this.loading = false
    },
    editWareHouse(row) {
      this.rowData = row
      this.dialogVisible1 = true
    },
    editRemark(row) {
      this.rowData = row
      this.dialogVisible2 = true
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tabItem {
    padding: 20px;
    width: 42px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    cursor: pointer;
  }
  .active {
    color:  rgb(18,88,188);
  }
  .opt {
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .search {
      position: relative;
      display: flex;
      width: 200px;
      margin-right: 5px;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: 0;
        }
        .close {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        width: 166px;
        height: 30px !important;
        /deep/ .el-input__inner {
          height: 30px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
    .import {
      width: 82px;
      height: 30px;
      background:  rgb(18,88,188);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      justify-content: center;
      cursor: pointer;
      align-items: center;
      margin-right: 5px;
      box-sizing: border-box;
    }
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    position: relative;
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
    p + p {
      margin-top: 4px
    }
    .pickUpType {
      display: inline-block;
      padding: 4px 12px;
      width: auto;
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      line-height: 16px;
    }
    .pickUpType0 {
      color: rgb(18, 88, 188);
      background: rgba(35, 149, 243, 0.1);
    }
    .pickUpType1 {
      color: rgb(157, 103, 254);
      background: rgba(157, 103, 254, 0.1);
    }
    .pickUpType2 {
      color: #feaa4f;
      background: rgba(254, 170, 79, 0.1);
    }
    .pickUpType3 {
      color: rgb(53, 186, 131);
      background: rgb(224, 249, 238);
    }
    .pickUpType4 {
      color: rgb(157, 103, 254);
      background: rgb(233, 221, 255);
    }
  }
  .lable {
    width: 80px;
    display: inline-block;
    height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    background: #f7f7f7;
    border-radius: 2px 2px 2px 2px;
    vertical-align: bottom;
    text-align: center;
  }
  .value {
    height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #666666;
    line-height: 20px;
    margin-left: 5px;
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
  margin-left: 10px
}
</style>
